import { definePanel } from '@/app/definePanel';
import { HealthMonitorIcon } from '@/components/occurra/icons/HealthMonitorIcon';
import { PanelMode, PanelTheme } from '@/types/panels';

export default definePanel({
    id: 'health_monitor',
    title: 'Health monitor',
    description: 'The state of every server and camera, to find a problem early.',
    icon: HealthMonitorIcon,
    // Server cards lay their counter groups out in columns; it takes the stage alone.
    width: { min: 560, default: 960, max: 2400, fill: true },
    modes: [PanelMode.Settings],
    // Health describes the system to the people who run it.
    requiresAdmin: true,
    themes: PanelTheme.Any,
    order: 3.43,
    // After the rules in the rail, before the audit log.
    navOrder: 3.73,
    urlSyncedProps: [],
});
